(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ifra-pair-builder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ifra-pair-builder')) {
  customElements.define('ifra-pair-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.selected = new Set();
      this.slots = this.querySelector('[data-slots]');
      this.cards = Array.from(this.querySelectorAll('.ifra-pair-builder__card'));
      this.submit = this.querySelector('[data-submit]');
      this.status = this.querySelector('[data-status]');
      this.error = this.querySelector('[data-error-message]');
      this.cards.forEach(card => {
        card.querySelector('[data-pick]').addEventListener('click', () => {
          if (this.busy || this.failed) return;
          if (this.selected.has(card)) this.selected.delete(card);
          else if (this.selected.size < 2) this.selected.add(card);
          this.render();
        });
      });
      this.submit.addEventListener('click', () => this.addPair());
      this.render();
    }
    render() {
      const count = this.selected.size;
      const message = [this.dataset.zero, this.dataset.one, this.dataset.two][count];
      this.status.textContent = message;
      this.slots.replaceChildren();
      const selections = Array.from(this.selected);
      for (let i = 0; i < 2; i++) {
        const slot = document.createElement('div');
        if (selections[i]) {
          const originalImage = selections[i].querySelector('img');
          if (originalImage) { const thumb = originalImage.cloneNode(); thumb.removeAttribute('sizes'); thumb.removeAttribute('srcset'); slot.append(thumb); }
          const name = document.createElement('span'); name.textContent = selections[i].querySelector('h2').textContent; slot.append(name);
        } else slot.textContent = (i + 1) + ' · ' + this.slots.dataset.empty;
        this.slots.append(slot);
      }
      this.submit.textContent = this.busy ? this.dataset.busy : message;
      this.submit.disabled = count !== 2 || this.busy || this.failed;
      this.cards.forEach(card => {
        const chosen = this.selected.has(card);
        const button = card.querySelector('[data-pick]');
        card.classList.toggle('is-selected', chosen);
        button.setAttribute('aria-pressed', String(chosen));
        button.textContent = chosen ? this.dataset.selected : this.dataset.add;
        button.disabled = this.busy || this.failed || (!chosen && count === 2);
        card.querySelector('select').disabled = chosen || this.busy || this.failed;
      });
    }
    async addPair() {
      if (this.selected.size !== 2 || this.busy || this.failed) return;
      const items = Array.from(this.selected, card => ({id: card.querySelector('select').value, quantity: 1}));
      this.busy = true;
      this.render();
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items})
        });
        if (!response.ok) throw new Error('cart');
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.failed = true;
        this.busy = false;
        this.error.textContent = this.dataset.error;
        this.error.hidden = false;
        this.querySelector('[data-review]').hidden = false;
        this.render();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
